<!-- MODALE PW DIMENTICATA -->
<div class="modal fade d-block" id="password-dimenticata"  tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" [class.show]="showResetPasswordModal" [style.z-index]="showResetPasswordModal ? 1050 : 0">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="showResetPasswordModal = false">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span *ngIf="!resetPasswordSuccess">
          <h5>{{'HAI_DIMENTICATO_LA_PASSWORD' | translate | htmlToText }}</h5>
          <p>{{'HAI_DIMENTICATO_LA_PASSWORD_ISTRUZIONI' | translate | htmlToText }}</p>
          <form class="">
              <div class="form-group">
                <label for="email" class="font-weight-semi-bold small">{{'INSERISCI_LA_TUA_MAIL' | translate | htmlToText}}*</label>
                <input type="email" class="form-control" id="email" name="emailResetPassword" aria-describedby="email" placeholder="" [(ngModel)]="emailResetPassword">
                <!-- ERRORE DATO INVALIDO -->
                <div class="small" *ngIf="erroreResetPassword"><i>{{'EMAIL_NON_TROVATA' | translate | htmlToText}}</i></div>
              </div>
          </form>
        </span>
        <span *ngIf="resetPasswordSuccess">
          <h5>{{'EMAIL_INVIATA_CON_SUCCESSO' | translate | htmlToText }}</h5>
        </span>

        
      </div>
      <div class="modal-footer">
        <div class="row" *ngIf="!resetPasswordSuccess">
          <div class="col-12">
            <button class="btn btn-stem" type="button" data-dismiss="modal" (click)="resetPassword()" [disabled]="!emailResetPassword">
              {{'INVIA_PASSWORD_TEMPORANEA' | translate | htmlToText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- //MODALE PW DIMENTICATA -->

<div class="container mb-md-5">
  <div class="row">
    <div class="col-12 col-md-6">
      <h2>{{'SEI_GIA_CLIENTE' | translate | htmlToText}}</h2>
      <p>{{'SE_SEI_GIA_CLIENTE_ACCEDI' | translate | htmlToText}}</p>
      <form class="">
        <div class="form-group">
          <label for="email" class="font-weight-semi-bold small">{{'EMAIL' | translate | htmlToText}}*</label>
          <input type="email" class="form-control" name="email" placeholder="" [(ngModel)]="jsonIn.email">
        </div>
        <div class="form-group">
            <label for="password" class="font-weight-semi-bold small">{{'PASSWORD' | translate | htmlToText}}*</label>
            <input type="password" class="form-control" name="password" placeholder="" [(ngModel)]="jsonIn.password">
        </div>
        <div class="form-inline mb-3">
          <button class="btn btn-stem mr-4" type="button" (click)="login()">
              {{'ACCEDI' | translate | htmlToText}}
            </button>
            <!--  CHI DIMENTICA PASSWORD RICEVE EMAIL CON PW PROVVISORIA E LINK AD AREA RISERVATA. DOVRA' MODIFICARLA. LA PASSWORD SCADE?-->
            <a (click)="showResetPasswordModal = true" class="small text-underline pointer">{{'PASSWORD_DIMENTICATA' | translate | htmlToText}}</a>
        </div>
        <div class="small">*{{'CAMPI_OBBLIGATORI' | translate | htmlToText}}</div>
        <!-- ERRORE CORRISPONDENZA -->
        <div class="is-invalid small" *ngIf="errorCredenziali"><i>{{'CREDENZIALI_ERRATE_LOGIN' | translate | htmlToText}}</i></div>
      </form>
    </div>

    <div class="col-12 col-md-6 my-5 mt-md-0">
      <h2>{{'SEI_UN_NUOVO_CLIENTE' | translate | htmlToText}}</h2>
      <p>{{'CREA_UN_ACCOUNT' | translate | htmlToText}}</p>
      <a appHref="/registrazione">
        <button class="btn btn-stem mt-3" type="button">
          {{'CREA_UN_ACCOUNT' | translate | htmlToText}}
        </button>
      </a>
      
    </div>
  </div>
</div>



  